module.exports = __webpack_public_path__ + "img/logo_header.95790c33.png";